export const OAKWYN_O_ICON_URL = "/images/logo-o-map-pin-30x30.svg";

export const GOOGLE_MAPS_PLACES_FIELDS = ['address_components', 'geometry', 'place_id', 'formatted_address']

export const GOOGLE_MAPS_PLACES_TYPES = ['street_address', 'locality', 'neighborhood', 'postal_code', 'point_of_interest'] // https://developers.google.com/maps/documentation/javascript/supported_types#table2